import React, { useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import { AuthContext } from "../../../context/Auth/AuthContext";
import ButtonUI from "../../material-ui/ButtonUI";
import permanentlyDeleteAllCategory from "../../../api/permanentlyDeleteAllCategory";

const PermanentlyDeleteAllCategory = ({
  setCategoryDeletedToTrue,
  isEntireTableRowsSelected,
  changeDropdownVisibilityFunc,
  id = [],
}) => {
  const [open, setOpen] = useState(false);
  const { token } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onPermanentDeleteAllCategory = async () => {
    const permanentDeleteAllCategoryFormResponse =
      await permanentlyDeleteAllCategory({
        token: token,
        id: id,
      });

    if (permanentDeleteAllCategoryFormResponse.code === 200) {
      setOpen(false);
      setCategoryDeletedToTrue(isEntireTableRowsSelected);
      changeDropdownVisibilityFunc();
      showSuccess("Categories is deleted successfully");
    }
  };

  return (
    <div className="dialog-modal">
      <div
        onClick={() => {
          handleClickOpen(id);
        }}
        className="deleteBtn"
      >
        Delete
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <MdDelete />
          </div>
          <div className="popup-header-title">
            Permanently Delete All Categories
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to permanently delete this categories ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            onClickFunc={onPermanentDeleteAllCategory}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PermanentlyDeleteAllCategory;
